import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","font-size":"14px"} }, [
  /*#__PURE__*/_createTextVNode("1、密码位数不能少于10位。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("2、密码中大写字母/小写字母/数字/特殊符号至少有三种。")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      width: "600px",
      visible: _ctx.visible,
      title: "修改密码",
      onCancel: _ctx.onClose,
      onOk: _ctx.onSubmit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_alert, {
          "show-icon": false,
          type: "warning",
          banner: "",
          style: {"margin-bottom":"15px"}
        }, {
          message: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_a_spin, {
          tip: "加载中...",
          spinning: _ctx.isLoading
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, {
              ref: "formRef",
              layout: "horizontal",
              model: _ctx.form,
              rules: _ctx.rules,
              "label-col": { span: 5 },
              "wrapper-col": { span: 16 }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: "旧密码",
                  name: "oldPass"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      value: _ctx.form.oldPass,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.oldPass) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "新密码",
                  name: "newPass"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      value: _ctx.form.newPass,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.newPass) = $event)),
                      valueModifiers: { trim: true }
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "重输新密码",
                  name: "repeatNewPassword"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      value: _ctx.form.repeatNewPassword,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.repeatNewPassword) = $event)),
                      valueModifiers: { trim: true }
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        }, 8, ["spinning"])
      ]),
      _: 1
    }, 8, ["visible", "onCancel", "onOk"])
  ]))
}